import { db } from './config';
import { collection, addDoc, query, where, getDocs, doc, updateDoc, deleteDoc } from 'firebase/firestore';

export const saveCertificate = async (certificateData) => {
  try {
    const certificateRef = await addDoc(collection(db, 'certificados'), {
      ...certificateData,
      fecha: certificateData.fecha || new Date().toISOString(),
      estado: certificateData.estado || 'activo'
    });
    return certificateRef.id;
  } catch (error) {
    console.error('Error guardando certificado:', error);
    throw error;
  }
};

export const getUserCertificates = async (userId, email) => {
  try {
    const certs = [];

    if (userId) {
      const byUserId = query(collection(db, 'certificados'), where('userId', '==', userId));
      const snapId = await getDocs(byUserId);
      certs.push(...snapId.docs.map((doc) => ({ id: doc.id, ...doc.data() })));   
    }

    if ((!certs.length) && email) {
      const byEmail = query(collection(db, 'certificados'), where('usuarioEmail', '==', email));
      const snapEmail = await getDocs(byEmail);
      certs.push(...snapEmail.docs.map((doc) => ({ id: doc.id, ...doc.data() }))); 
    }

    return certs;
  } catch (error) {
    console.error('Error obteniendo certificados:', error);
    return [];
  }
};

export const updateCertificate = async (id, data) => {
  const ref = doc(db, 'certificados', id);
  await updateDoc(ref, data);
};

export const deleteCertificate = async (id) => {
  const ref = doc(db, 'certificados', id);
  await deleteDoc(ref);
};